import { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { MentiSessionProvider } from '../context/MentiSessionContext';
import MentiDashboard from '../components/menti/host/MentiDashboard';
import MentiCreator from '../components/menti/host/MentiCreator';
import MentiSessionControl from '../components/menti/host/MentiSessionControl';
import MentiPresenter from '../components/menti/host/MentiPresenter';

export default function MentiHostPage() {
  const { sessionId: urlSessionId } = useParams();
  const navigate = useNavigate();
  const [view, setView] = useState(urlSessionId ? 'session' : 'dashboard');
  const [activeSessionId, setActiveSessionId] = useState(urlSessionId || null);
  const [editPresentation, setEditPresentation] = useState(null);

  useEffect(() => {
    if (urlSessionId) {
      setView('session');
      setActiveSessionId(urlSessionId);
    }
  }, [urlSessionId]);

  const handleCreateNew = () => {
    setEditPresentation(null);
    setView('create');
  };

  const handleEdit = (presentation) => {
    setEditPresentation(presentation);
    setView('create');
  };

  const handleSaved = () => {
    setEditPresentation(null);
    setView('dashboard');
  };

  const handleStartSession = useCallback((sessionId) => {
    setActiveSessionId(sessionId);
    setView('session');
    navigate(`/menti/session/${sessionId}`, { replace: true });
  }, [navigate]);

  const handlePresent = () => setView('presenter');
  const handleExitPresenter = () => setView('session');

  const handleBack = () => {
    setView('dashboard');
    setActiveSessionId(null);
    setEditPresentation(null);
    navigate('/menti', { replace: true });
  };

  if (view === 'create') {
    return (
      <MentiCreator
        presentation={editPresentation}
        onSave={handleSaved}
        onCancel={handleBack}
      />
    );
  }

  if (view === 'session' && activeSessionId) {
    return (
      <MentiSessionProvider sessionId={activeSessionId}>
        <MentiSessionControl
          onBack={handleBack}
          onPresent={handlePresent}
        />
      </MentiSessionProvider>
    );
  }

  if (view === 'presenter' && activeSessionId) {
    return (
      <MentiSessionProvider sessionId={activeSessionId}>
        <MentiPresenter onExit={handleExitPresenter} />
      </MentiSessionProvider>
    );
  }

  return (
    <MentiDashboard
      onCreateNew={handleCreateNew}
      onEdit={handleEdit}
      onStartSession={handleStartSession}
    />
  );
}
